import { getCommonMutationSideEffectConfigs } from "../common-mutation-side-effect-configs";
import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const USERS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"users"> = {
  updateOne: () => ({
    get_users_for_groups: {
      exact: false,
    },
  }),
  invite_user: (_request, response) => {
    const createOneUpdater = getCommonMutationSideEffectConfigs<"users">().createOne;
    if (!createOneUpdater || !response) return {};

    return createOneUpdater(response.created, response.created);
  },
};
